// @ts-ignore
import axios, { AxiosPromise, AxiosResponse, Method } from 'axios'
// @ts-ignore
import router from '@/router'
import { Message } from 'element-ui'
import store from "@/store";
// @ts-ignore
import { getToken, removeToken } from './../common/auth'

axios.defaults.timeout = 5000

const headers = {
  'Content-Type': 'application/json',
}

const request = axios.create({ baseURL: process.env.VUE_APP_BASE_API, headers })
request.interceptors.request.use(
  config => {
    config.headers.Authorization = getToken() || ''
    return config
  },
  error => Promise.reject(error),
)

request.interceptors.response.use(
  res => {
    if (res.status === 200) {
      const responseData = res.data
      if (responseData.code === 200) {
        return Promise.resolve(responseData)
      }
      if (responseData.code === 401){
        Message.error(responseData.msg)
        location.reload();
      } else {
        if (res.config.url==='/api/user/login'){
          store.dispatch('user/errData', res.data.msg)
        } else {
          // Message.error(responseData.msg?responseData.msg:'网络连接失败, 请稍后重试')

        }
      }
    } else {
      Message.error('网络连接失败, 请稍后重试')
    }
    return Promise.reject(res.data)
  },
  error => {
    if (error.response.status) {
      switch (error.response.status) {
        case 401:
          removeToken()
          router.replace({ path: '/login', query: { redirect: router.currentRoute.fullPath } })
          break
        case 403:
          Message.error('登录过期，请重新登录')
          removeToken()
          setTimeout(() => router.replace({ path: '/login', query: { redirect: router.currentRoute.fullPath } }), 1000)
          break
        case 404:
          Message.error('网络请求不存在')
          break
        case 502:
          Message.error('服务器开小差，请稍后重试')
          break
        case 500:
          Message.error('服务器开小差，请稍后重试')
          break
        default:
          Message.error(error.response.data.data.msg)
      }
      return Promise.reject(error.response.data)
    }
  },
)

const noop = () => void 0

interface Config {
  name?: string
  url: string
  method: string
  skip?: boolean
  isParams:boolean
}

interface ProxyConfig {
  [apiName: string]: string | Config
}


export class Service<T> {
  resolve: (response: AxiosResponse<T>) => void = noop
  reject: (error: any) => void = noop
  done: () => void = noop

  loadingTarget: string = ''
  context: any

  constructor (params: any, config: Config) {
    let fire: () => AxiosPromise

    let filteredParams: any = params
    if (params && !config.skip) {
      filteredParams = {}

      if (Array.isArray(params)) {
        filteredParams = params
      } else {
        Object.keys(params).forEach(key => {
          const val = params[key]
          filteredParams[key] = val

          // if (typeof val === 'number') {
          //   if (val === 0) {
          //     filteredParams[key] = 0
          //   }
          // }
          // if (typeof val === 'boolean') {
          //   if (val === false) {
          //     filteredParams[key] = false
          //   }
          // }
          //
          // if (val) {
          //   if (Array.isArray(val) && val.length === 0) {
          //     return
          //   }
          //   filteredParams[key] = val
          // }
        })
      }
    }

    if (config.method === 'post') {
      if(config.isParams){
       fire = ()=> request.post(config.url,null,{params:filteredParams})
      }else {
        fire = () => request.post(config.url, filteredParams)
      }
    } else if (config.method === 'delete') {
      fire = () => request.delete(config.url, { params: filteredParams })
    } else {
      fire = () => request.get(config.url, { params: filteredParams })
    }

    setTimeout(() => {
        if (this.context) {
        this.context[this.loadingTarget] = true
      }

      fire()
        .then(response => this.success(response))
        .catch(error => this.failure(error))
        .finally(() => this.end())

    }, 1)
  }

  then (callback: (response: AxiosResponse<T>) => void): this {
    this.resolve = callback
    return this
  }

  catch (callback: (error: any) => void): this {
    this.reject = callback
    return this
  }

  finally (callback: () => void): this {
    this.done = callback
    return this
  }

  loading (target: string, context: any): this {
    this.context = context
    this.loadingTarget = target
    return this
  }

  end () {
    if (this.context) {
      this.context[this.loadingTarget] = false
    }
    this.done()
  }

  success (response: AxiosResponse<T>) {
    try {
      this.resolve(response)
    } catch (e) {
      console.error(e)
    }
  }

  failure (error: any) {
    if (this.reject) {
      this.reject(error)
    } else {
      console.error(error)
    }
  }
}

export default class ApiProxy {
  [key: string]: (params?: any) => Service<any>

  constructor (proxyConfig: ProxyConfig) {
    Object.keys(proxyConfig).forEach(key => {
      const config = proxyConfig[key]
      let parseConfig: Config

      if (typeof config === 'string') {
        const special = config.split('?')[1]?.split(',')

        const option = config.split('?')[0].split(':')
        const isParams = config.split(':')[2]
        parseConfig = {
          url: option[1] || option[0],
          method: (option[1] ? option[0].toLowerCase() : 'get') as Method,
          skip: special?.includes('skip'),
          isParams:!!isParams
        }
      } else {
        config.method = config.method ? config.method.toLowerCase() : 'get'
        parseConfig = config
      }

      this[key] = (params: any) => new Service(params, parseConfig)
    })
  }
}
